﻿import toolbars from "./toolbars";

import de from './translations/de'
import en from './translations/en';

const colors = [
    {
        color: '#000000',
        label: 'Black'
    },
    {
        color: '#4D4D4D',
        label: 'Dim grey'
    },
    {
        color: '#999999',
        label: 'Grey'
    },
    {
        color: '#E6E6E6',
        label: 'Light grey'
    },
    {
        color: '#FFFFFF',
        label: 'White',
        hasBorder: true
    },
    {
        color: '#E64C4C',
        label: 'Red'
    },
    {
        color: '#E6994C',
        label: 'Orange'
    },
    {
        color: '#E6D628',
        label: 'Yellow'
    },
    {
        color: '#6BBD00',
        label: 'Light green'
    },
    {
        color: '#04BE45',
        label: 'Green'
    },
    {
        color: '#0BA0DA',
        label: 'Aquamarine'
    },
    {
        color: '#29A3A3',
        label: 'Turquoise'
    },
    {
        color: '#07C7F2',
        label: 'Light blue'
    },
    {
        color: '#4C4CE6',
        label: 'Blue'
    },
    {
        color: '#994CE6',
        label: 'Purple'
    }
];

const colorPickerConfig = {
    format: 'hex'
}

// Editor configuration.
const defaultConfig = {
    language: 'en',
    translations: [de, en],

    toolbar: {
        items: toolbars.Default,

        shouldNotGroupWhenFull: true,
    },

    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableProperties',
            'tableCellProperties'
        ],

        tableProperties: {
            borderColors: colors,
            backgroundColors: colors,
            colorPicker: colorPickerConfig,

            defaultProperties: {
                borderStyle: 'none',
                borderColor: '',
                borderWidth: '',
            },
        },

        tableCellProperties: {
            borderColors: colors,
            backgroundColors: colors,
            colorPicker: colorPickerConfig,

            defaultProperties: {
                borderStyle: 'none',
                borderColor: '',
                borderWidth: '',
            },
        }
    },

    fontColor: { colors: colors, colorPicker: colorPickerConfig },
    fontBackgroundColor: { colors: colors, colorPicker: colorPickerConfig },

    fontSize: {
        options: [
            'default',
            8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72
        ],
        supportAllValues: true
    },

    fontFamily: {
        supportAllValues: true
    },

    style: {
        definitions: [
            {
                name: 'Article category',
                element: 'h3',
                classes: ['category']
            },
            {
                name: 'Info box',
                element: 'p',
                classes: ['info-box']
            },
        ]
    },

    image: {
        insert: {
            type: 'inline'
        },
        resizeUnit: 'px',
        resizeOptions: [
            {
                name: 'resizeImage:original',
                value: null
            },
            {
                name: 'resizeImage:custom',
                value: 'custom'
            }
        ],
        toolbar: [
            'linkImage',
            '|',
            'imageTextAlternative',
            'imageSpacing',
            '|',
            'imageStyle:inline',
            'imageStyle:alignLeft',
            'imageStyle:alignRight',
            '|',
            'resizeImage'
        ]
    },

    list: {
        properties: {
            styles: true,
            startIndex: false,
            reversed: false
        }
    },

    lineHeight: {
        options: [
            '10px', '11px', '12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px',
            '21px', '22px', '23px', '24px', '25px', '26px', '27px', '28px', '29px', '30px', '31px',
            '32px', '33px', '34px', '35px', '36px', '37px', '38px', '39px', '40px', '41px', '42px',
            '43px', '44px', '45px', '46px', '47px', '48px', '49px', '50px', '51px', '52px', '53px',
            '54px', '55px', '56px', '57px', '58px', '59px', '60px', '61px', '62px', '63px', '64px',
            '65px', '66px', '67px', '68px', '69px', '70px', '71px', '72px'
        ],
    },

    htmlSupport: {
        allow: [
            {
                //Not necessary for table because CustomTableProperties handles classes and styles for tables
                name: /^(div|span|p|td)$/,
                classes: true,
                styles: true
            },
            {
                name: /^(div|table)$/,
                attributes: {
                    align: true
                }
            },
            {
                name: 'ul',
                styles: true
            },
            {
                name: 'ol',
                styles: true
            },
            {
                name: 'table',
                attributes: {
                    cellpadding: true,
                    cellspacing: true,
                    border: true
                }
            }
        ]
    },

    removePlugins: []
};

export default defaultConfig;